import orderStoreMutations from '@/state/orderStore/orderStoreMutations'
import orderStoreActions from '@/state/orderStore/orderStoreActions'
import getOrderStoreDefaultState from '@/state/orderStore/orderStoreDefaultState'
import { compare } from '../helpers'
import moment from 'moment'

let state = getOrderStoreDefaultState()

export let orderStore = {
  namespaced: true,
  state,
  getters: {
    mostRecentOrders: state => {
      let currentOrderList = state.currentOrdersList
      let lastThirtyDaysOrders = []
      // using moment js we can define end day usually the actual day and the start day substracting 30 day from the actual day
      let endDate = moment().format('MM/DD/YYYY')
      let startDate = moment(endDate)
        .subtract(30, 'days')
        .format('MM/DD/YYYY')

      while (startDate <= endDate) {
        currentOrderList.forEach(order => {
          let orderWasSentAt = moment(order.createdAt).format('MM/DD/YYYY')
          if (orderWasSentAt === startDate) {
            lastThirtyDaysOrders.unshift(order)
          }
        })

        startDate = moment(startDate)
          .add(1, 'days')
          .format('MM/DD/YYYY')
      }
      return lastThirtyDaysOrders.sort(compare)
    },
    charactersLeft: state => {
      return state.maxCharacters - state.cardMessage.length
    }
    // myOrders: state => userId => {
    //   let ownOrders = state.currentOrdersList.filter(
    //     order => order.userId === userId
    //   )
    //   return ownOrders.sort(compare)
    // },
    // teamOrders: state => {
    //   /*
    //     List entire team orders except the ones related to group orders "redemption"
    //   */
    //   let { currentOrdersList } = state
    //   currentOrdersList = currentOrdersList.filter(
    //     order => order.paigeGroupOrderId === null
    //   )
    //   return currentOrdersList.sort(compare)
    // },
    // redemptionOrders: state => {
    //   // List entire redemption orders only
    //   let { currentOrdersList } = state
    //   currentOrdersList = currentOrdersList.filter(
    //     order => order.paigeGroupOrderId !== null
    //   )
    //   return currentOrdersList.sort(compare)
    // }
  },
  mutations: orderStoreMutations,
  actions: orderStoreActions
}
